import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Store } from '@ngrx/store';
import { AppState } from '../models/app-state.models';
import { sessionActions } from 'src/app/store/actions';

@Injectable({ providedIn: 'root' })
export class BreakpointsService {
    private maxWidthBP = '(max-width: 992px)';

    constructor(
        private breakpointObserver: BreakpointObserver,
        private store: Store<AppState>
    ) {

        this.store.dispatch(sessionActions.updateIsMobile(
            {
                status: this.breakpointObserver.isMatched(this.maxWidthBP)
            }
        ));

        this.breakpointObserver.observe(this.maxWidthBP)
            .subscribe(
                result => this.store.dispatch(sessionActions.updateIsMobile(
                    {
                        status: result.matches
                    }
                ))
            );

    }

}
